import { NavLink } from "react-router-dom";
import { BarChart3, Mail, Send, PenLine } from "lucide-react";
import { cn } from "@/lib/utils";

const tabs = [
  { to: "/admin/emails", label: "Visão Geral", icon: BarChart3, end: true },
  { to: "/admin/emails/templates", label: "Templates", icon: Mail },
  { to: "/admin/emails/log", label: "Log de Envios", icon: Send },
  { to: "/admin/emails/send", label: "Disparo Manual", icon: PenLine },
];

export function EmailTabNav() {
  return (
    <nav className="flex items-center gap-1 mb-6 border-b border-border -mx-6 lg:-mx-8 px-6 lg:px-8">
      {tabs.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              "flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors duration-200",
              isActive
                ? "border-primary text-primary"
                : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
            )
          }
        >
          <tab.icon className="w-4 h-4" />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
